// extracted by mini-css-extract-plugin
export default {"preTitle":"vehicleItem_preTitle__3lbeC","lineButtons":"vehicleItem_lineButtons__K6SaT","twoInLine":"vehicleItem_twoInLine__8tDFS"};